<template>
    <div class="BoxWide">
        <div class="TabellaGenerale">
            <div class="loader" v-show="this.isLoading"></div> 
            <table width="100%" border="0" cellspacing="0" cellpadding="0" v-show="!this.isLoading">               
                <tbody>
                    <tr>
                        <th scope="col">Codice Contratto</th>      
                        <th scope="col">Data Contratto</th>
                        <th scope="col"> Stato </th>
                        <th scope="col"> Descrizione </th>
                        <th scope="col">Data Inizio</th>
                        <th scope="col"> Data Fine Validià </th>
                        <th scope="col"> Siti </th>
                        <th scope="col"> Tipo Scadenza </th>
                        <th scope="col"> Revisione </th>
                    </tr>
                    <RigaGrigliaContratti v-for="(contratto, index) in this.listaContrattiShow" :key="index" :index="index" :rigaContratti="contratto"> </RigaGrigliaContratti>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>

    import RigaGrigliaContratti from "@/components/RigaGrigliaContratti.vue";

    export default {
        name: "GrigliaContratti",  
        components: {
            RigaGrigliaContratti
        },
        data(){
            return {
                listaContrattiShow: null,
                isLoading: true
            }
        },
        props: {
            listaContratti: Array
        },
        watch:{
            listaContratti: function(newValue){
                this.listaContrattiShow = newValue;
                this.isLoading = false;
            }
        }
    }
</script>